import React from 'react';

import { Box, Skeleton } from '@mui/material';

import { useBreakpointV2 } from '@helpers/use';

const BundleCourseItemContentSkeleton = () => {
  const { isMobile } = useBreakpointV2();

  if (isMobile) {
    return (
      <Skeleton
        animation="wave"
        variant="rectangular"
        sx={{ width: '100%', height: '600px', borderRadius: 2, marginTop: 2 }}
      />
    );
  }

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        gap: { md: 2 },
      }}
    >
      <Skeleton animation="wave" variant="rectangular" sx={{ width: '100%', height: '198px', borderRadius: 2 }} />
      <Skeleton animation="wave" variant="rectangular" sx={{ width: '100%', height: '198px', borderRadius: 2 }} />
      <Skeleton animation="wave" variant="rectangular" sx={{ width: '100%', height: '198px', borderRadius: 2 }} />
    </Box>
  );
};

export default BundleCourseItemContentSkeleton;
